import React from 'react';
import Style from './formPreview.module.css';
import { Select, InputLabel, InputSublabel } from '@weezevent/nacre';
import i18n from '../../../i18n/i18n';
import getLabel from './utils';
import { useTranslation } from 'react-i18next';

export default function FormSelect({ field, label, value = null, id = null, onChangeForm = () => {} }) {
    const { t } = useTranslation();

    const [_value, setValue] = React.useState(null);

    const onChange = React.useCallback(
        v => {
            if (id) {
                onChangeForm(id, v);
                return;
            }
            setValue(v);
        },
        [id]
    );

    const choices = React.useMemo(() => {
        return field.form_field.question_choices.map(obj => {
            return {
                key: obj.weez_id,
                text: getLabel(i18n.language, 'label', obj.translations, obj.label),
                value: obj.label
            };
        });
    }, [field, i18n]);

    return (
        <div className={Style['field']}>
            <InputLabel label={label} required={field.required} />
            {field.form_field.description && <InputSublabel label={field.form_field.description} />}
            <Select placeholder={t('ticket.common.action.select')} options={choices} value={id ? value : _value} onChange={value => onChange(value)} {...field} />
        </div>
    );
}
